import { render } from "./DDFavorites.vue?vue&type=template&id=3a79b5f6"
import script from "./DDFavorites.vue?vue&type=script&lang=js"
export * from "./DDFavorites.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__